import { styled } from "@mui/material/styles";

import CardMedia from "@mui/material/CardMedia";

const CustomCardMedia = styled(CardMedia)(({ theme }) => ({
    width: 50,
    "&:hover": {
      transform: "scale(1.05)",
      transition: "transform 0.3s ease",
    },
  }));

export default CustomCardMedia;
